import { apiFetch } from '../utils/apiFetch';

const apiUrl = process.env.REACT_APP_API_URL;

export async function getMyPermissions() {
  try {
    const response = await apiFetch(`${apiUrl}/permissions/me`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch permissions');
    }

    const data = await response.json(); // <-- YES you need this
    return data;
  } catch (error) {
    console.error('Failed to fetch permissions:', error);
    return {}; // safe fallback
  }
}
